(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["addreview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hjertechakra-addreview')) {
    customElements.define('hjertechakra-addreview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.form = this.querySelector('form');
        this.setupRating();
        this.form.addEventListener('submit', (event) => this.submit(event));
      }

      setupRating() {
        const group = this.querySelector('.hc-addreview__rating');
        const buttons = Array.from(group.querySelectorAll('button'));
        const input = this.querySelector('input[name="rating"]');
        const paint = (value) => buttons.forEach((button, index) => {
          button.textContent = index < value ? '★' : '☆';
        });
        const select = (value, focus) => {
          input.value = String(value);
          buttons.forEach((button, index) => {
            const selected = index + 1 === value;
            button.setAttribute('aria-checked', String(selected));
            button.tabIndex = selected ? 0 : -1;
          });
          paint(value);
          if (focus) buttons[value - 1].focus();
        };

        buttons.forEach((button) => {
          const value = Number(button.dataset.ratingValue);
          button.tabIndex = value === 1 ? 0 : -1;
          button.addEventListener('click', () => select(value, false));
          button.addEventListener('pointerenter', () => paint(value));
          button.addEventListener('focus', () => paint(value));
          button.addEventListener('keydown', (event) => {
            let next = Number(input.value) || value;
            if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = Math.min(5, next + 1);
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = Math.max(1, next - 1);
            else if (event.key === 'Home') next = 1;
            else if (event.key === 'End') next = 5;
            else return;
            event.preventDefault();
            select(next, true);
          });
        });

        group.addEventListener('pointerleave', () => paint(Number(input.value) || 0));
        group.addEventListener('focusout', (event) => {
          if (!group.contains(event.relatedTarget)) paint(Number(input.value) || 0);
        });
      }

      async submit(event) {
        event.preventDefault();
        const message = this.querySelector('.hc-addreview__message');
        const submitButton = this.form.querySelector('[type="submit"]');
        const data = new FormData(this.form);
        const rating = Number(data.get('rating'));
        message.hidden = true;

        if (!rating) {
          message.textContent = this.dataset.ratingError;
          message.hidden = false;
          this.querySelector('.hc-addreview__rating button').focus();
          return;
        }

        if (!this.form.reportValidity()) return;
        submitButton.disabled = true;
        submitButton.textContent = this.dataset.sending;

        try {
          const separator = this.dataset.apiUrl.includes('?') ? '&' : '?';
          const endpoint = `${this.dataset.apiUrl}${separator}action=create`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify({
              name: data.get('name'),
              rating,
              headline: data.get('headline'),
              text: data.get('text'),
              website: data.get('website')
            })
          });
          const result = await response.json();
          if (!response.ok || !result.success) throw new Error(result.message || this.dataset.formError);
          const success = this.querySelector('.hc-addreview__success');
          this.classList.add('is-success');
          this.form.hidden = true;
          success.hidden = false;
          success.focus();
        } catch (error) {
          message.textContent = error.message || this.dataset.formError;
          message.hidden = false;
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = this.dataset.send;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hjertechakra-review-list')) {
    customElements.define('hjertechakra-review-list', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.page = 0;
        this.total = 0;
        this.pageSize = Math.min(50, Math.max(1, Number(this.dataset.pageSize) || 10));
        this.querySelector('[data-load-more]')?.addEventListener('click', () => this.loadMore().catch(() => {}));
        this.load();
      }

      async request(action) {
        const separator = this.dataset.apiUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${this.dataset.apiUrl}${separator}${action}`);
        let result;
        try {
          result = await response.json();
        } catch (error) {
          throw new Error(this.dataset.error);
        }
        if (!response.ok || !result.success) throw new Error(result.message || this.dataset.error);
        return result;
      }

      async load() {
        try {
          const summary = await this.request('action=summary');
          this.renderSummary(summary);
          if (this.dataset.displayMode !== 'compact') await this.loadMore();
          this.querySelector('.hc-review-list__loading').hidden = true;
          this.querySelector(this.dataset.displayMode === 'compact' ? '.hc-review-list__compact' : '.hc-review-list__full').hidden = false;
        } catch (error) {
          this.querySelector('.hc-review-list__loading').hidden = true;
          const errorElement = this.querySelector('.hc-review-list__error');
          errorElement.textContent = this.dataset.error;
          errorElement.hidden = false;
        }
      }

      renderSummary(summary) {
        const numericAverage = Math.min(5, Math.max(0, Number(summary.average) || 0));
        const average = numericAverage.toLocaleString('da-DK', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        this.querySelectorAll('.hc-review-list__average').forEach((element) => { element.textContent = average; });
        const label = Number(summary.count) === 1 ? this.dataset.reviewOne : this.dataset.reviewMany;
        this.querySelectorAll('.hc-review-list__count').forEach((element) => {
          element.textContent = this.dataset.displayMode === 'compact'
            ? `${summary.count} ${label}`
            : `${this.dataset.basedOn} ${summary.count} ${label}`;
        });
        this.querySelectorAll('.hc-review-list__summary-stars').forEach((element) => {
          element.style.setProperty('--rating-fill', `${(numericAverage / 5) * 100}%`);
          element.setAttribute('aria-label', `${average} ${this.dataset.outOfFive}`);
        });
        this.querySelectorAll('.hc-review-list__distribution-row').forEach((row) => {
          const count = Number(summary.distribution?.[row.dataset.rating] || 0);
          const percentage = summary.count > 0 ? (count / summary.count) * 100 : 0;
          row.querySelector('strong').textContent = count;
          row.querySelector('.hc-review-list__bar span').style.width = `${percentage}%`;
        });
      }

      async loadMore() {
        const button = this.querySelector('[data-load-more]');
        if (button) button.disabled = true;
        try {
          const nextPage = this.page + 1;
          const result = await this.request(`action=list&page=${nextPage}&pageSize=${this.pageSize}`);
          this.page = nextPage;
          this.total = Number(result.total || 0);
          result.reviews.forEach((review) => this.renderReview(review));
          if (button) button.hidden = this.page * this.pageSize >= this.total;
        } finally {
          if (button) button.disabled = false;
        }
      }

      renderReview(review) {
        const article = document.createElement('article');
        article.className = 'hc-review-list__review';

        const stars = document.createElement('div');
        stars.className = 'hc-review-list__stars';
        const rating = Math.min(5, Math.max(1, Number(review.rating) || 1));
        stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
        stars.setAttribute('aria-label', `${rating} / 5`);

        const time = document.createElement('time');
        time.dateTime = review.created;
        const date = new Date(review.created);
        time.textContent = Number.isNaN(date.valueOf())
          ? ''
          : new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);

        const top = document.createElement('div');
        top.className = 'hc-review-list__review-top';
        top.append(stars, time);
        article.append(top);

        if (review.headline) {
          const heading = document.createElement('h4');
          heading.textContent = review.headline;
          article.append(heading);
        }

        const text = document.createElement('p');
        text.textContent = review.text;
        article.append(text);

        const meta = document.createElement('div');
        meta.className = 'hc-review-list__review-meta';
        const avatar = document.createElement('span');
        avatar.className = 'hc-review-list__avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.textContent = (review.name || '?').trim().charAt(0) || '?';
        const name = document.createElement('strong');
        name.textContent = review.name;
        meta.append(avatar, name);


        article.append(meta);
        this.querySelector('.hc-review-list__items').append(article);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
